import classnames from 'classnames'
import { filter, get, isArray, map } from 'lodash'
import React, { cloneElement, isValidElement, ReactNode } from 'react'
import styled from 'styled-components'

import { TButton } from '../Button'

const Wrapper = styled.div``

export interface TButtonGroup extends TButton {
  nowrap?: boolean
}

const ButtonGroup = (props: TButtonGroup): React.ReactElement => {
  const { children = [], nowrap = false, ...rest } = props

  const childrenFiltered = Array.isArray(children)
    ? filter(children, (c) => isValidElement(c) || typeof c === 'string')
    : [children]

  if (childrenFiltered.length === 0) {
    return <></>
  }

  return (
    <Wrapper className={classnames('m-n1', { 'text-nowrap': nowrap })}>
      {React.Children.map(childrenFiltered, (child, index) =>
        React.cloneElement(child as any, {
          key: index,
          className: `${get(child, 'className', '') || ''} m-1 d-inline-block`,
          ...rest,
        }),
      )}
    </Wrapper>
  )
}

export default ButtonGroup
